import { add, differenceInDays, format, formatISO, getDaysInMonth, lastDayOfMonth, parse, parseISO, sub } from "date-fns"

export function goTo(id) {
  this.$vuetify.goTo(id).then(() => {
    if (!id) {
      return (document.location.hash = '')
    }
    if (history.replaceState) {
      history.replaceState(null, null, id)
    } else {
      document.location.hash = id
    }
  })
}

export function formatDate(date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export function parseDate(date) {
  if (!date) return null
  const [day, month, year] = date.split('/')
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export function daysBetween(date1, date2) {
  var a = parseISO(date1);
  var b = parseISO(date2);
  return differenceInDays(a, b)
}

export function getDateClass(datediffdays) {
  if (datediffdays > 90) {
    return "warningLevel5";
  } else if (datediffdays > 60) {
    return "warningLevel4";
  } else if (datediffdays > 30) {
    return "warningLevel3";
  } else if (datediffdays > 0) {
    return "warningLevel2";
  } else {
    return "warningLevel1";
  }
}

// export function showByteArray(genericByteArrayWrapper) {
//   const byteArray = new Uint8Array(genericByteArrayWrapper.byteArray);
//   const blob = new Blob([byteArray], {
//     type: genericByteArrayWrapper.mimeType
//   });
//   showBlob(blob);
// }

export function booleanStrongStyle(value) {
  if (value) {
    return "booleanStrongTrue";
  }
  return "booleanStrongFalse";
}

export function booleanConverter(value) {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

// export function showString(string) {
//   const blob = new Blob([string], {
//     type: 'text/plain'
//   });
//   showBlob(blob);
// }

export function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export function showBlob(blob) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
  } else {
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl);
  }
}

export function downloadBlob(filename, blob) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
  } else {
    const objectUrl = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    link.click();
  }
}

export function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function objectValues(v, k) {
  if (typeof v == "object") {
    for (var kp in v) {
      if (Object.hasOwnProperty.call(v, kp)) {
        objectValues(v[kp], k != undefined ? k + "." + kp : kp);
      }
    }
  } else {
    console.log(k + ":" + v);
  }
}

export function nameFormatted(name, format) {
  let result = "EMPTY";
  if (name && name != "") {
    if (name.includes(";")) {
      const parts = name.split(";");
      const surname = parts[0];
      const forename = parts[1];
      const title = parts[2];
      if (format == "initials") {
        result = initials(forename) + initials(surname);
      } else if (format == "index") {
        result = surname + ", " + forename + ", " + title;
      } else if (format == "full") {
        result = title + " " + forename + " " + surname;
      } else if (format == "fullnotitle") {
        result = forename + " " + surname;
      } else if (format == "shortname") {
        result = title + " " + initials(forename) + " " + surname;
      } else if (format == "salutation") {
        result = title + " " + surname;
      } else if (format == "system") {
        result = initials(forename) + " " + surname;
      } else if (format == "beginning") {
        result = beginning(surname, 3);
      } else if (format == "forename") {
        result = forename;
      } else if (format == "surname") {
        result = surname;
      } else if (format == "title") {
        result = title;
      }
    } else {
      if (format == "initials") {
        result = beginning(name, 3);
      } else if (format == "beginning") {
        result = beginning(name, 3);
      } else {
        result = name;
      }
    }
  }
  return result;
}

function initials(name) {
  let result = " ";
  if (name) {
    result = "";
    const initials = stringClean(name).split(" ");
    initials.forEach((initial) => {
      if (initial.length > 0) {
        result += initial.substring(0, 1);
      }
    });
  }
  return result;
}

function beginning(value, n) {
  value = value.replace("[^A-Za-z]+", "");
  if (value.length >= n) {
    value = value.substring(0, n);
  }
  return value.toUpperCase();
}

function stringClean(value) {
  value = value.trim(); // trim leading and trailing spaces
  value = value.replace("\r", ""); // remove carriage returns
  value = value.replace(" +", " "); // remove multiple spaces
  return value;
}

export function formatCurrency(value) {
  var formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
}

export function sortTimestamp(a, b) {
  return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
}

export function sortTimestampDesc(a, b) {
  return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
}

export function sortValue(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}

export function vectorNotBlank(list, name) {
  return list.filter(q => q[name]).map(q => q[name])
}

export function mapResults(target, list, name, nameshort) {
  return target.map(element => {
    const item = list.find(i => i.id === element[name]);
    if (item) {
      return { ...element, [nameshort]: item };
    } else {
      return element;
    }
  });
}

export function convertListOfObjectsToMap(list, nameOfId) {
  return list.reduce(function (map, obj) {
    map[obj[nameOfId]] = obj;
    return map;
  }, {});
}

export function convertListOfObjectsToArrayMap(list, nameOfId) {
  return list.reduce(function (map, obj) {
    map[obj[nameOfId]] = map[obj[nameOfId]] || [];
    map[obj[nameOfId]].push(obj);
    return map;
  }, {});
}

export function printElement(elementId) {
  // Get HTML to print from element
  const prtHtml = document.getElementById(elementId).innerHTML;
  // Get all stylesheets HTML
  let stylesHtml = '';
  for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
    stylesHtml += node.outerHTML;
  }
  // Open the print window
  const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
  const rawHtml = `<!DOCTYPE html>
  <html>
    <head>
      ${stylesHtml}
    </head>
    <body>
      ${prtHtml}
    </body>
  </html>`;
  // console.log(rawHtml);
  WinPrint.document.write(rawHtml);
  WinPrint.document.close();
  window.setTimeout(() => {
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }, 300)

}

export function int2ip(ipInt) {
  return ((ipInt >>> 24) + '.' + (ipInt >> 16 & 255) + '.' + (ipInt >> 8 & 255) + '.' + (ipInt & 255));
}

export function ip2int(ip) {
  return ip.split('.').reduce(function (ipInt, octet) { return (ipInt << 8) + parseInt(octet, 10) }, 0) >>> 0;
}

export function buttonList() {
  return [
    { id: 0, name: "Quotation" },
    { id: 1, name: "Instruct now" },
    { id: 2, name: "Instruction confirmation" },
    { id: 3, name: "Callback" },
    { id: 4, name: "Unsubscribe offers" }
  ];
}

export function instructedList() {
  return [
    { id: 1, name: "instructed" },
    { id: 2, name: "enquiry" },
  ];
}

export function getCalendarMini(date, selected) {
  date = !date ? new Date() : parse(date, 'yyyyMMdd', new Date())

  const calendarMini = {
    date: formatISO(date),
    theMonth: format(date, "MMMMM yyyy"),
    weekOfYear: getWeek(date),
    yearRange: {
      start: formatISO(sub(date, { years: 1 })),
      end: formatISO(add(date, { years: 1 })),
      colour: '#eeeeee'
    },
    monthRange: {
      start: formatISO(sub(date, { months: 1 })),
      end: formatISO(add(date, { months: 1 })),
      colour: '#eeeeee'
    },
    weekRange: {
      start: formatISO(sub(date, { weeks: 1 })),
      end: formatISO(add(date, { weeks: 1 })),
      colour: '#eeeeee'
    },
    dayRange: {
      start: formatISO(sub(date, { days: 1 })),
      end: formatISO(add(date, { days: 1 })),
      colour: '#eeeeee'
    }
  }

  const dateSQL = new Date(date)
  const today = new Date(new Date().toDateString())

  // set to last day of the month
  const daysInMonth = getDaysInMonth(date)
  const dayOfFinalWeek = lastDayOfMonth(date).getDay()
  let endOffset = dayOfFinalWeek == 0 ? 0 : 8 - dayOfFinalWeek

  // store month
  const theMonth = date.getMonth()

  // set to first day of the month
  const firstDayOfMonth = sub(date, { days: date.getDate() - 1 })
  // show whole week
  const dayOfWeekStart = firstDayOfMonth.getDay()
  // if sunday move to previous monday
  let startOffset = dayOfWeekStart == 0 ? 6 : dayOfWeekStart - 1
  // number of days in month plus offset
  let count = daysInMonth + startOffset + endOffset;

  // move calendar after setting count to avoid changing month too early
  let calendar = sub(firstDayOfMonth, { days: startOffset })

  // store start
  const dateRange = {
    start: formatISO(calendar)
  }

  const weekMinis = []
  let dayMinis = []
  for (let i = 0; i < count; i++) {
    const dayOfWeek = calendar.getDay()
    const calendarDateSQL = new Date(calendar)
    const month = calendar.getMonth()
    const dayMini = {
      date: formatISO(calendar),
      year: calendar.getFullYear(),
      dayOfMonth: calendar.getDate(),
      month: month + 1,
      monthYear: format(calendar, "MMMMM yyyy"),
      dayOfWeek,
      dow: format(calendar, "EEEE")
    }
    if (today.getTime() === calendarDateSQL.getTime()) {
      dayMini.colour = "#ccccff"
      dayMini.styleClass = "today"
    } else if (theMonth != month) {
      dayMini.colour = "#aaaaaa"
      dayMini.styleClass = "nextmonth"
    } else if (dayOfWeek == 0 || dayOfWeek == 6) {
      dayMini.colour = "#dddddd"
      dayMini.styleClass = "weekend"
    }
    if (selected && dateSQL.getTime() === calendarDateSQL.getTime()) {
      // mark selected
      dayMini.colour = "#99dd99"
      dayMini.styleClass = "selected"
    }
    dayMinis.push(dayMini);
    calendar = add(calendar, { days: 1 })
    if (i == count - 1 && dayOfWeek != 0) {
      // if last day but not sunday add days
      count += 6 - dayOfWeek;
    }
    if (dayOfWeek == 0) {
      // end week if sunday
      weekMinis.push({ days: [...dayMinis] })
      // clear list for next lot
      dayMinis = []
    }
  }
  calendarMini.weeks = weekMinis

  // store end
  dateRange.end = formatISO(calendar)
  calendarMini.dateRange = dateRange

  return calendarMini;
}

function getWeek(date) {
  // Remove time components of date
  const targetThursday = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  )

  // Change date to Thursday same week
  targetThursday.setDate(
    targetThursday.getDate() - ((targetThursday.getDay() + 6) % 7) + 3
  )

  // Take January 4th as it is always in week 1 (see ISO 8601)
  const firstThursday = new Date(targetThursday.getFullYear(), 0, 4)

  // Change date to Thursday same week
  firstThursday.setDate(
    firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3
  )

  // Check if daylight-saving-time-switch occurred and correct for it
  const ds =
    targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset()
  targetThursday.setHours(targetThursday.getHours() - ds)

  // Number of weeks between target Thursday and first Thursday
  const weekDiff = (targetThursday - firstThursday) / (86400000 * 7)
  return 1 + Math.floor(weekDiff)
}

export function graphQLErrorMessages(err) {
  if (!err.graphQLErrorMessages) {
    return
  }
  const errors = err.graphQLErrors[0]
  const messages = []
  if (errors.hasOwnProperty('functionError')) {
    const customErrors = JSON.parse(errors.functionError)
    messages.push(...customErrors.errors)
  } else {
    messages.push(errors.message)
  }
  return messages
}

export function convertMinsToHrsMins(mins) {
  let h = Math.floor(mins / 60);
  let m = Math.round(mins % 60);
  h = (h < 10) ? ('0' + h) : (h);
  m = (m < 10) ? ('0' + m) : (m);
  return `${h}:${m}`;
}

export function getClientHeaders() {
  const screen = window.screen;
  const timezoneOffsetInMinutes = new Date().getTimezoneOffset();
  const sign = timezoneOffsetInMinutes >= 0 ? "-" : "+";
  const hrsMins = convertMinsToHrsMins(Math.abs(timezoneOffsetInMinutes));
  return {
    userAgent: window.navigator.userAgent,
    timezone: `UTC${sign}${hrsMins}`,
    screen: {
      width: screen.width,
      height: screen.height,
      "scaling-factor": 1,
      "colour-depth": screen.colorDepth
    },
    window: {
      width: screen.availWidth,
      height: screen.availHeight
    }
  };
}